import { AttributeTypes } from '@/common/enum';

export default class AttributeModel {
  public id!: number;
  public type!: AttributeTypes;
  public typeDescription!: string;
  public description!: string;
  public imageUrl?: string;
  public price!: number;

  constructor() {
    this.imageUrl = '';
  }
}

// tslint:disable-next-line: max-classes-per-file
export class AttributeFilterParams {
  public attributeId!: number;
  public type!: AttributeTypes;
}

// tslint:disable-next-line: max-classes-per-file
export class AttributePriceParams extends AttributeFilterParams {
  public isParent!: boolean;
}

// tslint:disable-next-line: max-classes-per-file
export class SelectedAttributeModel extends AttributeModel {
  public title!: string;
  // public step!: number;

  constructor() {
    super();
  }
}
